import React from "react";
import { Link } from "react-router-dom";

const RouterLink = ({ to, className, children }) => <Link {...{ to, className, children }} />;

export default RouterLink;
